export default function initForm() {
    document.addEventListener('DOMContentLoaded', () => {
        function handleSelects() {
            // select fix start -> typo3 forms ext v11 can't display a empty value for select
            const selects = document.querySelectorAll('select.isnack-form-single-select');

            selects.forEach((select) => {
                if (!select.hasAttribute('required')) {
                    if (!select.value.trim()) {
                        const optionDash = select.querySelector('option[value=""]');
                        optionDash.value = '-'; // eslint-disable-line no-param-reassign
                    }
                } else if (select.value === '-') {
                    const optionDash = select.querySelector('option[value="-"]');
                    optionDash.value = ''; // eslint-disable-line no-param-reassign
                }
            });
        }

        function formAfterSubmitAction(form, submitter) {
            // Prefer the button that actually triggered the submit (event.submitter).
            // form.querySelector('button[type="submit"]') always returns the FIRST submit
            // button in DOM order, which on multi-step forms with a "Previous step" button
            // (EXT:form's Navigation.html renders it before Next/Submit) is the wrong button.
            // Fallback for browsers without event.submitter: the first submit button that is
            // NOT the "Previous step" button (that one always carries formnovalidate).
            const submitButton = submitter || form.querySelector('button[type="submit"]:not([formnovalidate])');
            const modalTrigger = document.getElementById('triggerloading');

            modalTrigger.click();

            if (submitButton) {
                submitButton.classList.add('isnack-disabled');
            }
        }

        function handleFakeMandatory() {
            const elements = document.querySelectorAll('.fake-mandatory');

            elements.forEach((element) => {
                const elementId = element.id;
                const parentContainer = element.parentElement;
                const textId = elementId.replace('-fakeMandatory', '');
                const field = document.getElementById(textId);
                const label = document.querySelector(`label[for='${textId}']`);

                if (field.required === false) {
                    field.required = true;
                    label.textContent += ' *';
                }

                field.addEventListener('blur', () => {
                    // if field is empty, show box
                    if (parentContainer.classList.contains('d-none') && !field.value.trim()) {
                        parentContainer.classList.remove('d-none');
                    }

                    // if field is not empty, hide box
                    if (field.value.trim()) {
                        parentContainer.classList.add('d-none');
                    }
                });

                element.addEventListener('change', () => {
                    // If the checkbox is not checked, set the input field as required
                    if (!element.checked) {
                        field.required = true;
                        if (!label.textContent.includes('*')) {
                            label.textContent += ' *';
                        }
                        if (field.classList.contains('isnack-form-single-select')) {
                            handleSelects();
                        }
                    } else {
                        // If the checkbox is checked, remove the required attribute from the input field
                        field.required = false;
                        if (label.textContent.includes('*')) {
                            label.textContent = label.textContent.replace(' *', '');
                        }
                        if (field.classList.contains('isnack-form-single-select')) {
                            handleSelects();
                        }
                    }
                });
            });
        }

        function removeVerifaliaFormFields() {
            /*
            * as long as verifalia javascript adds additional input field with name="something[email]-added-by-verifalia",
            * our TYPO3 doesn't know these filds in its form validation and "trustedProperties".
            * even worse, the array in the email field with name="something[email]" will be overwritten with the last value in name="something[email]-added-by-verifalia",
            * so our form finisher will recieve an "invalid email" here.
            *
            * after all verifalia checks, we remove the verifalia fields on submit.
            */
            const verifalia = document.querySelectorAll('.verifalia-field.verifalia-field-valid');

            verifalia.forEach((element) => {
                const name = element.getAttribute('name');
                const statusId = document.getElementById(name + '-verifalia-status');
                statusId.remove();
                const classificationId = document.getElementById(name + '-verifalia-classification');
                classificationId.remove();
                const idId = document.getElementById(name + '-verifalia-id');
                idId.remove();
            });
        }

        // trigger
        handleFakeMandatory();
        handleSelects();

        // load fallback trigger
        window.addEventListener('load', () => {
            handleFakeMandatory();
            handleSelects();
        });

        // Fetch all the forms we want to apply custom Bootstrap validation styles to
        const forms = document.querySelectorAll('.needs-validation');
        // Loop over them and prevent submission
        // eslint-disable-next-line
        Array.prototype.slice.call(forms).forEach(function (form) {
            const submitLimitCounter = document.getElementById(form.id + '-submitLimit');
            let warning;

            if (submitLimitCounter) {
                const ceId = 'c' + submitLimitCounter.getAttribute('data-submitLimitId');
                warning = document.getElementById(ceId);

                // hide warning ce (may not exist on every page, e.g. the multi-step
                // form's summary page without input fields)
                if (warning) {
                    warning.classList.add('d-none', 'kpcc-helper');
                }
            }
            // eslint-disable-next-line
            form.addEventListener('submit', function (event) {
                // eslint-disable-next-line
                if (!form.checkValidity()) {
                    event.preventDefault();
                    event.stopPropagation();
                }
                form.classList.add('was-validated');

                // submitLimitCounter logic
                if (submitLimitCounter && warning) {
                    const requiredFields = form.querySelectorAll('[required]');
                    let allRequiredFieldsFilled = true;

                    Array.prototype.slice.call(requiredFields).forEach((field) => {
                        if (!field.value.trim()) {
                            const parentContainer = field.parentElement;
                            const checkContainer = parentContainer.querySelector('.form-check');

                            if (checkContainer && checkContainer.classList.contains('d-none')) {
                                checkContainer.classList.remove('d-none');
                            }

                            allRequiredFieldsFilled = false;
                        }
                    });

                    // count up if submit is not possible
                    // show warning if submit failed twice
                    if (!allRequiredFieldsFilled) {
                        submitLimitCounter.textContent = parseInt(submitLimitCounter.textContent, 10) + 1;
                        if (submitLimitCounter.textContent === '2') {
                            warning.classList.remove('d-none');
                        }
                    }
                }

                // eslint-disable-next-line
                if (form.checkValidity()) {
                    removeVerifaliaFormFields();

                    // Only guard against button spam on "forward" navigation
                    // (Next step / final Submit). The "Previous step" button always
                    // carries formnovalidate (see EXT:form's Navigation.html partial)
                    // and must stay untouched/clickable.
                    const { submitter } = event;
                    const isForwardSubmit = !submitter || !submitter.hasAttribute('formnovalidate');

                    if (isForwardSubmit) {
                        formAfterSubmitAction(form, submitter);
                    }
                }
            }, false);
        });
    });
}
